var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({class:_vm.chipClasses,attrs:{"data-samora":"","tabindex":"-1"}},_vm.disabled || !_vm.interactive ? {} : _vm.$listeners),[_vm._t("prepend"),_c('span',{staticClass:"sam-chip__label"},[(!_vm.$slots.default)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._e(),_vm._t("default")],2),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }